import { Component, OnInit, ElementRef, SimpleChanges, HostListener } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { ConsoleInfo, HcrService } from 'src/app/services/hcr-service.service';
import { UserConfirmService } from 'src/app/services/user-confirm.service';
import { IPatient } from 'src/app/services/api-service/patient/patientsDto';
import { BaseConfig } from 'src/app/services/base-config.service';
import { TrimEnd, verifyTaiwanIdIntermediateStringAndMsg } from 'src/app/shared/utilities';
import { CnhiEiiService } from 'src/app/services/cnhi-eii.service';
import { MatDialog } from '@angular/material/dialog';
import { CnhiEiiTestComponent } from '../cnhi-eii-test/cnhi-eii-test.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SatellitePharmacyServiceService } from 'src/app/services/satellite-pharmacy-service.service';
import { VisDialogComponent } from 'src/app/shared/components/dialog/vis-dialog/vis-dialog.component';

import { LabApi } from 'src/app/services/api-service/labs/lab-api';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { IcHelper } from 'src/app/shared/helpers/ic-helper';
import { HPCHelper } from 'src/app/shared/helpers/hpc-helper';
import { EasyFormService } from 'src/app/services/easy-form-service';
import { BasicData } from 'src/app/shared/hcr-lib/BasicData';
import { VisionHIS6 } from 'src/app/shared/hcr-lib/VisionHIS6';
import { UserCache } from 'src/app/services/user-cache';
import { VICHelper } from 'src/app/shared/helpers/vic-helper';
import { ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { ConsoleApi } from 'src/app/services/api-service/console-api.service';
import { GridDialogComponent } from 'src/app/shared/components/dialog/grid-dialog/grid-dialog.component';
import { LocalStoragesService } from 'src/app/services/local-storages.service';

@Component({
  selector: 'app-hcr-console',
  templateUrl: './hcr-console.component.html',
  styleUrls: ['./hcr-console.component.css']
})
export class HcrConsoleComponent implements OnInit {
  isHCREnable = false;
  isHcrDemo = false;
  hcrVersion = '';
  dllVer =0;
  hospName = '';
  hospAbbName = '';
  statusSAM = '';
  samNo = '';
  statusHC = '';
  statusHPC = '';
  cardReaderHC = '';
  cardReaderHPC = '';
  HCInfo:BasicData = null;
  versionOption = [
    {text:'1.0.0',value:'1.0.0'},
    {text:'2.0.0',value:'2.0.0'}]
  demoPatient: IPatient;

  useWebApi:boolean;

  comx:ValueTextPair[] = []
  licenseMsg = '';
  licenseStatus = false;
  get licenseInfo(){
    if(this.hcrService.supportVersion('1.1.2')){
      return `(${this.licenseMsg})`;
    }
  }
  get prevDemoPatientWhenRand():boolean{
    return this.hcrService.prevDemoPatientWhenRand;
  }
  prevPatChanged(evt:MatCheckboxChange){
    this.hcrService.prevDemoPatientWhenRand = evt.checked;
  }
  isDebugMode(){
    return BaseConfig.isDebug();
  }

  constructor(
    private notification: EasyNotificationService,
    private hcrService: HcrService,
    private satelliteService:SatellitePharmacyServiceService,
    private confirmService: UserConfirmService,
    private labApi:LabApi,
    private consoleApi:ConsoleApi,
    private matDialog:MatDialog,
    private hpcHelper:HPCHelper,
    private ezForm:EasyFormService,
    private vicHelper:VICHelper,
    private localStorage:LocalStoragesService
    
  ) {
      this.hcrService.SetHcrConsoleComponent(this);

     }
  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => {
      this.nowWidth = window.innerWidth;
      this.getRatio();
    }, 500);
  }

  nowWidth:number = window.innerWidth;
  bigRatio: boolean = false;
  getRatio() {
		if (this.nowWidth < 1251 ) {
      this.bigRatio = true;
    } else this.bigRatio = false;
  }
  async ngOnInit() {
    // this.isHCREnable = this.hcrService.ConnectStatus;
    // if(this.isHCREnable){
    //   await this.getHcrVersion();
    //   await this.getHospName();
    //   await this.getCardStatus();
    //   await this.getCardReader();
    // }
    this.nowWidth = window.innerWidth;
    this.getRatio();
    this.useWebApi = HcrService.useWebApi;
    this.force6check = this.hcrService.VisionHis6?.forceOfficialAPI??false;
    await this.satelliteService.getHost();
    
    // await this.GetPaper();
  }
  bodyHeight = document.body.clientHeight;
  getRealHeight():number {
    let resultHeight = this.bodyHeight - 90
    return resultHeight;
  }
  consoleInfo:ConsoleInfo;
  satelliteStatus:boolean=false;
  get satelliteEnable(){
    return this.satelliteService.useSatellite();
  }
  get satelliteHost(){
    return this.satelliteService.Host;
  }
  async tryHost(host:string){
    await this.satelliteService.trySend(host);
  }
  public UpdateConsoleInfo(isConnected){
    //沒有在用
    setTimeout(async () => {
      this.isHCREnable = isConnected;
      if(isConnected){
        this.hospName = '';
        await this.getComXList();
        if(await this.getHcrVersion()){
          await this.getHospName();
          await this.getCardStatus();
        }
        await this.getCardReader();
        if(this.satelliteService.useSatellite()){
          // this.satelliteStatus = (await  this.satelliteService.trySend()).Successed;
          this.satelliteStatus = true;
        }
        this.consoleInfo = await this.hcrService.logConsoleInfo()
        if(!this.IsVer6&& !this.consoleInfo.SAMInstalled){
          this.hospName += '(尚未置入SAM檔)'
        }
      }
    }, 0);
  }
  async HpCardChanged(isInsert:boolean){
    var wait = 0;
    if(isInsert){
      this.statusHC = '讀取中...'
      wait = 1000;
    }
    setTimeout(async () => {
      await this.getHCStatus();
    },wait);

  }
  async HpcCardChanged(isInsert:boolean){
    var wait = 0;
    if(isInsert){
      this.statusHPC = '讀取中...'
      wait = 1000;
    }
    setTimeout(async () => {
      await this.getHPCStatus();
    },wait);
  }

  async getCardReader(){
     var ret = await this.hcrService.GetCardReaderInfo()
    if(ret.Successed){
      setTimeout(() => {
        this.cardReaderHC = ret.Returns.HC;
        this.cardReaderHPC = ret.Returns.HPC;
      }, 0);
    }
  }
  async getCardStatus(){
    await this.getHCStatus();
    await this.getSAMStatus();
    await this.getHPCStatus();

  }
  async getSAMStatus(){
    var ret = await this.hcrService.VisionApi.GetCardStatusSAM()
    if(ret.StatusCode == 0){
      this.statusSAM = ret.Data;
    }
    var samNo = await this.hcrService.VisionApi.GetCardNoSAM()
    if(samNo.StatusCode == 0){
      this.samNo = samNo.Data;
    }else{
      this.samNo = ''
    }
  }
  get IsVer6(){
    return this.hcrService.IsVer6;
  }
  force6check = false;
  onForce6Checked(evt:MatCheckboxChange){
    this.hcrService.VisionHis6.forceOfficialAPI = evt.checked
  }
  async changeSam(){
    if(this.hcrService.IsVer6){
      var sams = await this.hcrService.VisionHis6.GetCloudSAMs();
      var sam = sams.Data.sams.find(x=>x.samId == this.samNo);
      if(sams.StatusCode!=0){
        await this.confirmService.showAlert('讀取可用之SAM卡失敗!',`(${sams.StatusCode})${sams.ErrorMsg}`)  
        return;
      }
      var ret =await this.ezForm.show<{sam:string}>({
        title:'切換Sam檔',
        width:600,
        msg:'請注意：若SAM卡與當前院所設定支機構代碼不一致，恐造成資料異常!!!'+
            '\n當前機構代碼為'+UserCache.getLoginUser().Clinic.NHICode+
            (this.samNo?('\n當前SAM卡號為: '+this.samNo):'') +
            (sam?('\n當前SAM卡機構為: ('+sam?.hospitalId+') '+sam?.hospitalName):''),
        fields:{
          sam:{
            data:sams.Data.sams.map(x=>{
              return {value:x.samId,text:`(${x.hospitalId}) ${x.hospitalName}`}
            }),
            name:'sam',
            value:this.samNo,
            type:'dropdown',
            label:'SAM卡號',
          }
        },
        btns:[
          {
            text:'新增',
            callback:async ()=>{
              await new Promise<boolean>((rs)=>{
                var input = document.createElement('input');
                input.type = 'file';
                input.accept='.sam';
                input.onchange = async (event:any)=>{
                  const file:File = event.target.files[0];
                  var hospId = file.name.substring(0,10)
                  var samNo = file.name.substring(10,22)
                  var buffer = await file.arrayBuffer();
                  var b = new Uint8Array(buffer);
                  var context = btoa(String.fromCharCode.apply(null,b));
                  var newSam =await this.hcrService.VisionHis6.AddCloudSAM(samNo,hospId,context);
                  await this.confirmService.showAlert('操作完成','已新增SAM卡 '+newSam.Data.samId+' :\n機構 ('+newSam.Data.hospitalId+')'+newSam.Data.hospitalName);  
                  rs(true);
                }
                input.click();
              })
              return {action:'close',data:null}
            }
          }
        ],
        closeValue:()=>null
      });
      if(ret?.sam && ret?.sam!=this.samNo){
        await this.hcrService.VisionHis6.Finalize();
        await this.hcrService.VisionHis6.Initial(ret.sam)
        await this.SamValidate();
        await this.confirmService.showAlert('操作完成','SAM卡已切換至'+sams.Data.sams.find(x=>x.samId==ret.sam).hospitalName);  
      }
    }else{
      await this.confirmService.showAlert('當前不支援此功能!','僅搭配雲端控制軟體6.0時才可切換sam檔')
    }
    
  }
  async getHPCStatus(){
    var ret = await this.hcrService.VisionApi.GetCardStatusHPC()
    if(ret.StatusCode == 0){
      this.statusHPC = ret.Data;
    }
  }
  async getHCStatus(){
    var ret = await this.hcrService.VisionApi.GetCardStatusHC()
    if(ret.StatusCode == 0){
      this.statusHC = ret.Data;
    }
  }
  async getHospName(){
    var ret = await this.hcrService.VisionApi.GetHospName()
    if(ret.StatusCode == 0){
      var name =TrimEnd(ret.Data,'\0');
      this.hospName = name;
    }
    try{
      var ret = await this.hcrService.VisionApi.GetHospAbbName()
      if(ret.StatusCode == 0){
        var name =TrimEnd(ret.Data,'\0');
        this.hospAbbName = name;
      }
    }catch(ex){
      this.hospAbbName = ''
    }
  }
  async getComXList(){
    var list = await this.hcrService.getCOMXList();
    this.comx = list.map(x=>{
      return {
        value:x.ComX,
        text:x.NHICode + '('+x.Name+')',
        extension:x.NHICode
      }
    })
  }
  async getHcrVersion():Promise<boolean>{
    try{
      var dllVerRet = await this.hcrService.VisionApi.GetVersionEx()
      if(dllVerRet.StatusCode==0){
        this.dllVer = dllVerRet.Data;
        return true
      }else{
        return false;
      }
    }catch(x){
      return false;
    }
  }
  async SamValidate(){
    try{
      var ret = await this.hcrService.VisionApi.VerifySAMDC()
      if(ret.StatusCode!=0){
        this.notification.showWarning(ret.ErrorMsg);
      }else{
        this.notification.showSuccess('SAM認證成功')
        await this.getCardStatus();
      }
    }catch(e){
    }
  }
  async UpdateHC(){
    var ret = await this.hcrService.VisionApi.UpdateHCContents();
    if(ret.StatusCode!=0){
      this.notification.showWarning(ret.ErrorMsg);
    }else{
      this.notification.showSuccess('更新完成')
      await this.getCardStatus();
    }
  }

  async getHCInfo(){
    var ret = await this.hcrService.VisionApi.GetBasicData()
    if(ret.StatusCode == 0){
      
        this.HCInfo = ret.Data;
      await this.ezForm.show({
          msg:'',
          title:'卡片資訊',
          fields:{
            Name:{ name:'Name', label:'姓名', value:ret.Data.Name, type:'display' },
            CId:{ name:'CId', label:'姓名', value:ret.Data.CId, type:'display' },
            Birth:{ name:'Birth', label:'生日', value:DateHelper.getROCDateString(ret.Data.Birth), type:'display' },
            ICNo:{ name:'ICNo', label:'卡號', value:ret.Data.IcNo, type:'display' },
            Sex:{ name:'Sex', label:'性別', value:ret.Data.Sex, type:'display' },
          }
        })
      
    }
  }
  async CheckPINHPC(){
    var result = await this.hpcHelper.CheckPin();
    if(result){
      await this.getCardStatus();
    }
    // var ret = await this.hcrService.VisionApi.VerifyHPCPIN('');
    // if(ret.StatusCode!=0){
    //   this.notification.showWarning(ret.ErrorMsg);
    // }else{
    //   this.notification.showSuccess('驗證成功')
    //   await this.getCardStatus();
    // }
  }
  async UnlockHPCCard(){
    var result = await this.hpcHelper.Unlock();
    if(result){
      await this.getCardStatus();
    }
  }
  async resetSAMStatus(){
    // 6.0 先重載
    if(this.hcrService.IsVer6){
      //要先run
      var runRet = await this.hcrService.RunNHI();
      if (!runRet.Successed) {
        this.notification.showWarning(runRet.Returns || '無法啟動雲端控制軟體');
        return;
      }
      await this.hcrService.VisionHis6.Finalize();
      await this.hcrService.VisionHis6.Initial();
    }
    var ret = await this.hcrService.VisionApi.SoftwareResetSAM()
    if(ret.StatusCode == 0){
      this.notification.showSuccess('重置SAM完成');
    }else{
      this.notification.showWarning('重置SAM失敗');
    }
  }
  async resetHPCStatus(){
    var ret = await this.hcrService.VisionApi.SoftwareResetHPC()
    if(ret.StatusCode == 0){
      this.notification.showSuccess('重置醫事人員卡完成');
    }else{
      this.notification.showWarning('重置醫事人員卡失敗');
    }
  }
  async resetHCStatus(){
    var ret = await this.hcrService.VisionApi.SoftwareResetHC()
    if(ret.StatusCode == 0){
      this.notification.showSuccess('重置IC卡完成');
    }else{
      this.notification.showWarning('重置IC卡失敗');
    }
  }
  async resetCRStatus(isConnected: boolean){
    //this.isHCREnable = isConnected;
      // if(isConnected){
      //   await this.getHospName();
      //   await this.getCardReader();
      // }
    var ret = await this.hcrService.VisionApi.SoftwareResetCR()
    if(ret.StatusCode == 0){
      this.notification.showSuccess('重置讀卡機完成');
    }else{
      this.notification.showWarning('重置讀卡機失敗');
    }
  }
  async reload(){
    var ret = await this.hcrService.Reload()
    if(ret.Successed){
      this.notification.showSuccess('重載完成');
    }else{
      this.notification.showWarning('重載失敗');
    }
  }
  async changeComX(){
    var ret = await this.ezForm.show({
      title:'切換COMX',
      msg:'切換COMX',
      fields:{
        comx:{
          label:'COMX',
          name:'comx',
          type:'dropdown',
          data:this.comx,
          value:this.comx.find(x=>x).value
        }
      },
      closeValue:()=>null
    });
    if(ret){
      var hCode = this.comx.find(x=>x.value ==ret.comx).extension;
      await this.hcrService.changeCOMX(hCode);
      await this.getHospName();
      await this.SamValidate();
    }

  }
  async changeVersion(ver:'5157'|'60'){
    var consoleVer = this.consoleInfo?.Mods?.find(x=>x.Name=='Vision.PrintConsole')?.Ver;
    var currentVersion = consoleVer?.split('.').map(x=>parseInt(x, 10));
    var minimumVersion = [1, 0, 39];
    var isUnsupported = !currentVersion || currentVersion.length != minimumVersion.length || currentVersion.some(x=>isNaN(x));
    if(!isUnsupported){
      for(var i=0; i<minimumVersion.length; i++){
        if(currentVersion[i] != minimumVersion[i]){
          isUnsupported = currentVersion[i] < minimumVersion[i];
          break;
        }
      }
    }
    if(isUnsupported){
      await this.confirmService.showAlert('不支援此功能','請更新您的展望主控台至1.0.39以上');
      return
    }
    var ck = await this.confirmService.showConfirm({
      title:'切換版本',width:350,
      msg:'是否將雲端控制軟體切換至 ' +ver+' 版本'+(ver=='5157'?'\n切換後若讀卡產生延遲請重新開機或重新登入作業系統':'')
    });
    if(!ck){
      return;
    }
    // console.log(evt.value)
    var ret = await this.hcrService.changeApiVersion(ver);
    if(ret.Successed == true){
      //新安裝
      if(ret.Returns==true ){
        if(ver=='60'){
          var reload = await this.confirmService.showConfirm({
            title:'切換版本',width:350,
            msg:'6.0版本的雲端控制軟體安裝後須重新整理網頁\n是否立即重整？'
          });
          if(reload==true){
            window.location.reload();
          }
        }else if(ver=='5157'){
          await this.confirmService.showAlert('切換版本',
            '5157版本的雲端控制軟體安裝後請自行重新開機或者重新登入作業系統。'
          );
        }
      }
      await this.hcrService.Close(false)
      try{
        await this.hcrService.Connect(false)
      }catch{}
      
      //await this.getHcrVersion();
    }
  }

  async changePCSC(){
    var readerRet = await this.hcrService.VisionHis6.GetPCSCs()
    if(readerRet.StatusCode==0){
      var readers = readerRet.Data.readers;
      var reader = (await this.hcrService.VisionHis6.GetPCSC())?.Data?.readerName??'';
      var ret =await this.ezForm.show<{reader:string}>({
        title:'切換讀卡機設備',
        width:600,
        msg:'當前讀卡機為: '+reader,
        fields:{
          reader:{
            data:readers.map(x=>{
              return {value:x,text:x}
            }),
            name:'reader',
            value:reader,
            type:'dropdown',
            label:'讀卡機名稱',
          }
        },
        btns:[
          {
            text:'清除',
            callback:async ()=>{
              var r = await this.hcrService.VisionHis6.ClearPCSC();
              if(r.StatusCode==0){      
                await this.confirmService.showAlert('操作完成','讀卡機設定已清除');  
                var info = await this.hcrService.ReloadCardReaderInfo()
                console.log(info)
                this.cardReaderHC = info.Returns.HC;
                this.cardReaderHPC = info.Returns.HPC;
              }
              return {action:'close',data:null}
            }
          }
        ],
        closeValue:()=>null
      });
      if(ret?.reader && ret?.reader!= reader){
        var ret2 = await this.hcrService.VisionHis6.SetPCSC(ret.reader)
        if(ret2.StatusCode==0){
          await this.confirmService.showAlert('操作完成','讀卡機已切換至'+ret.reader);  
          //更新主控台資訊
          var info = await this.hcrService.ReloadCardReaderInfo()
          this.cardReaderHC = info.Returns.HC;
          this.cardReaderHPC = info.Returns.HPC;
        }else{
          await this.confirmService.showAlert('操作失敗',ret2.ErrorMsg);
        }
        
      }
    }
  }
  enableDemo(evt:MatButtonToggleChange ){
    var checked = !this.isHcrDemo;// evt.source.checked;
    this.hcrService.setDemoMode(checked);
    this.notification.showSuccess((checked?'啟用':'停用')+'展示模式');
    this.isHcrDemo = checked;
    if(this.isHcrDemo==true){
      this.demoPatient = this.hcrService.demoPatient();
    }
  }

  receivePatientChange(evt: any){
    console.log(evt);
  }
  print(){
    this.hcrService.PrintTest();
  }
  update(){
    this.hcrService.Update()
  }

  async openApp(){
    var s = await this.hcrService.openVisionHis();
    if(!s){
      alert('Uninstall');
    }
  }
  async openAppNoUpdate(){
    var s = await this.hcrService.openVisionHis(true);
    if(!s){
      alert('Uninstall');
    }
  }

  getChromeVersion () {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return raw ? parseInt(raw[2], 10) : -1;
  }
  cnhieiiTest(evt){
    var diag = this.matDialog.open(CnhiEiiTestComponent,{
      disableClose:true,
      panelClass:'CnhiEiiTestWidth',
      width:'95%',
      maxWidth:'95vw'
    });
    diag.componentInstance.onClose.subscribe(x=>diag.close());
    //this.cnhi_eii.GetHospType
  }
  async dayliUploadTest(evt){
    var file = await this.hcrService.SelectFiles()
    var ret = await this.hcrService.VisionApi.UploadData(file.FullName,"60");
    if(ret.StatusCode==0){
      if(ret.Data){
        await this.confirmService.showAlert('執行成功',
        '醫事服務機構代碼: \t'+ ret.Data.HospId+'\n'+
        '上傳日期時間: \t'+ ret.Data.UploadDateTime+'\n'+
        '接收日期時間: \t'+ ret.Data.RecieveDateTime+'\n'+
        'DC接收檔案筆數: \t'+ ret.Data.RecieveNumber+'\n'+
        'DC接收檔案大小: \t'+ ret.Data.RecieveSize+' (Byte)\n'+
        '安全模組代碼: \t'+ ret.Data.SAMId+'\n',{'fitContent':true}
        );
      }else{
        this.notification.showSuccess('執行成功');
      }
    }else{
      this.notification.showError(ret.ErrorMsg);
    }
  }
  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    setTimeout(() => {
      this.nowWidth = window.innerWidth;
      // 一併更新高度，否則視窗改變後 dialog 仍用建立元件當下的舊值
      this.bodyHeight = document.body.clientHeight;
      this.getRatio();
    }, 500);
  }
  tNum:string;
  async getTreat(){
    var hosp = await this.hcrService.VisionApi.GetHospID();
    var cid='HC30575172';
    cid='A123456789'
    var ret = await this.hcrService.VisionApi.webApiGetTreatNumNoIC(cid,hosp.Data);
    var ret2 = await this.hcrService.VisionApi.webApiGetTreatNum(cid,hosp.Data,'1131105080808');

    var tNum = ret.Data;
  }

  useWebApiChecked(evt:MatCheckboxChange){
    HcrService.useWebApi = evt.checked;
  }
  vhcStatus:string = '';
  // async onQRCodeScanResult(code:string,dialog:VisDialogComponent){
  //   dialog.show =false;
  //   var ret = await this.hcrService.VHCApi.uploadqrcode(code)
  //   if(ret.StatusCode!=0){
  //     this.notification.showError(ret.ErrorMsg);
  //   }else{
  //     this.notification.showSuccess(ret.ErrorMsg);
  //   }
  //   var cardStatus = await this.hcrService.VHCApi.GetCardStatusHC();
  //   this.vhcStatus = cardStatus.Data;
  //   console.log(code)
  // }
  // async clearVHC(){
  //   var ret = await this.hcrService.VHCApi.cleanQRCode()
  //   if(ret.StatusCode!=0){
  //     this.notification.showError(ret.ErrorMsg);
  //   }else{
  //     this.notification.showSuccess(ret.ErrorMsg);
  //   }
  // }
  // async VHCStatus(){
  //   var ret = await this.hcrService.VHCApi.GetCardStatusHC()
  //   this.confirmService.showAlert("結果",JSON.stringify(ret));
  // }
  // async VHCBasic(){
  //   var ret = await this.hcrService.VHCApi.GetBasicData()
  //   this.confirmService.showAlert("結果",JSON.stringify(ret));
  // }
  // async VHCRegBasic(){
  //   var ret = await this.hcrService.VHCApi.GetRegisterBasic()
  //   this.confirmService.showAlert("結果",JSON.stringify(ret));
  // }
  // async VHCTreat(){
  //   var ret = await this.hcrService.VHCApi.GetTreatmentNoNeedHPC()
  //   console.log(ret);
  //   var ret2 = await this.hcrService.VHCApi.QuickInsurence('')
  //   console.log(ret2);
  //   this.confirmService.showAlert("結果",JSON.stringify(ret)+'\n\n' + JSON.stringify(ret2));
  // }
  // // 需醫師卡
  // async VHCTreat2(){
  //   var ret = await this.hcrService.VHCApi.GetTreatmentNeedHPC()
  //   console.log(ret);
  //   var ret2 = await this.hcrService.VHCApi.ReadPrescription();
  //   console.log(ret2);
  //   this.confirmService.showAlert("結果",JSON.stringify(ret) + '\n\n' + JSON.stringify(ret2));
  // }
  // async VHCIsq(){
  //   var ret = await this.hcrService.VHCApi.GetLastSeqNum()
  //   console.log(ret);
  //   this.confirmService.showAlert("結果",JSON.stringify(ret));
  // }
  async CreateFakeResult(){
    try{
      await this.labApi.CreateFakeResult();
      this.notification.showSuccess('造假完成');
    }catch(e){
      this.notification.showError(e);
    }
  }
  async GetPaper(){
    var ret  = await this.hcrService.GetPaperSize(2);
    await this.confirmService.showAlert('結果',JSON.stringify(ret));
  }

async UploadLog(){
  var region = await this.ezForm.show({
    title:'上傳紀錄',
    msg:'請選擇起訖區間',
    fields:{
      Sdate:{
        type:'date',
        label:'起始',
        name:'Sdate',
        value: new Date()
      },
      Edate:{
        type:'date',
        label:'結束',
        name:'Edate',
        value:new Date()
      }
    }, closeValue:(x)=>null
  });
  if(region){
    var ret = await this.hcrService.UploadLog(region.Sdate,region.Edate);
    var result = ret.Returns as {Count:number,Failed:string[]};
    await this.confirmService.showAlert('上傳完成',`上傳成功 ${result.Count}筆。\n上傳失敗：\n`
      + (result.Failed.length==0 ? '無' : result.Failed.concat('...').filter((x,i)=>i<10).join('\n'))
    );
  }
}

  treat_hinno:string = '';
  treat_dt:Date = new Date();
  treat_tm:string = '';
  treat_cid:string = '';
  treat_no:string = '';
  async TestITreat(){
      //var a = new VisionHisDemo(null);
      //3532018235
      //HTU4AY G21LNZC 3AF1D3W
      //this.getTreatId('7431110698','G221489822',new Date(2023,7,21,15,11,44))
      this.treat_no = '';
      var dt = new Date(this.treat_dt.toLocaleDateString() + ' ' + this.treat_tm)
      this.treat_no = this.getTreatId(this.treat_hinno,this.treat_cid,dt)
      console.log('目標：HTU4AYG21LNZC3AF1D3W')

      //this.getTreatInfo(this.treat_no);
  }
  ParseTreat(){
    this.getTreatInfo(this.treat_no);
  }
  ClearTreat(){
    this.treat_hinno = '';
    this.treat_dt = new Date();
    this.treat_tm = '';
    this.treat_cid = '';
    this.treat_no = '';
  }
  private getITreatString(n: number) {
    var char = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
    var calcTemp = Math.floor(n);
    var treatIdBuild = ''
    do {
        var a = calcTemp % char.length;
        treatIdBuild = char[a] + treatIdBuild;
        calcTemp = Math.floor(calcTemp / char.length)
    }
    while (calcTemp > 0)
    return treatIdBuild;
  }
  private getITreatNum(s: string) {
    var char = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
    var n  = 0 ;
    for(let c of s){
      var i = char.indexOf(c);
      n *= char.length
      n += i;
    }

    return n;
  }
  /** 第一欄請自行複製6碼 */
  public getTreatId(nhiCode:string,cid:string,dt:Date) {
    //機構代馬 (6)
    var c1 = nhiCode;// this.getITreatString(parseInt(nhiCode));
    // 身分證 前2馬保留
    var cCid1 = cid.substring(0, 2)
    // 身分證 3-9碼 轉成5碼 (身分證檢查碼跳過)
    var code = cid.substring(2, 9)
    var cCid2 = this.getITreatString(parseInt(code));
    // 年份 2碼
    var cYr = this.getITreatString(dt.getFullYear()-1911);
    // 時間5碼
    var secDiff = (dt.getTime() - new Date(dt.getFullYear(), 0, 1, 0, 0, 0).getTime()) / 1000
    var cDt = this.getITreatString(secDiff).padStart(5,'0');

    console.log('轉換：',nhiCode,cid,dt)
    console.log('結果：'+c1 + cCid1 + cCid2 + cYr + cDt);
    return c1 + cCid1 + cCid2 + cYr + cDt;
  }
  public getTreatInfo(treatNo:string) {
    //機構代馬 (6)
    var c1 = treatNo.substring(0,6);// this.getITreatString(parseInt(nhiCode));
    // 身分證 前2馬保留
    var cCid1 = treatNo.substring(6, 8)
    // 身分證 3-9碼 轉成5碼 (身分證檢查碼跳過)
    var code = treatNo.substring(8, 13)
    var cCid2 = this.getITreatNum(code);
    var cid = `${cCid1}${cCid2}0`;
    var cCid3 = verifyTaiwanIdIntermediateStringAndMsg(cid,true).validateNum; // 身分證驗證碼
    var cid = `${cCid1}${cCid2}${cCid3}`;
    // 年份 2碼
    var cYr = this.getITreatNum(treatNo.substring(13,15));
    // 時間5碼
    var cSec = this.getITreatNum(treatNo.substring(15,20))
    var dt = new Date(new Date(cYr+1911,0,1,0,0,0).getTime()+cSec*1000);

    this.treat_hinno = c1;
    this.treat_cid = cid;
    this.treat_dt = dt;
    this.treat_tm = DateHelper.getTimeString(dt,':')
    console.log('結果：'+cid +', ' + dt);

  }

  async readQR(){
    await this.vicHelper.readQr()
    await this.getHCStatus();
  }
  async removeVHC(){
    await this.vicHelper.clearVHC();
    await this.getHCStatus();
  }

  async restore(){
    var list = await this.consoleApi.GetConsoleBackUp(UserCache.getLoginUser().Clinic.Code);
    
    var dialogRef = this.matDialog.open(GridDialogComponent, {
      width: '800px',
      disableClose:true
    });
    var c: GridDialogComponent<ConsoleInfo> = dialogRef.componentInstance as GridDialogComponent<ConsoleInfo>;
    var data = list.Files;
    if(!BaseConfig.isDebug()){
      // 非debug模式下只顯示與自己同IP來源電腦 不想被使用者看到其他登入來源
      data = data.filter(x=>x.IP == list.IP);
    }
    var localinfo: ConsoleInfo = this.localStorage.getItem('ConsoleInfo')
    
    c.gridData = list.Files;
    c.title = '主控台設定檔';
    c.pageSize = 8;
    c.headers = {
      ComputerName:{ title:'電腦名稱',width:80,order:1,pipe:d=>{
        var cName = decodeURIComponent(d.ComputerName);
        if(localinfo.ComputerName == cName){
          return `(本機)${cName}`
        }
        return cName;
        
      }},    
      IP:{ title:'IP',width:80,order:1,pipe:d=>d.IP},
      DateTime:{ title:'備份時間',width:80,order:2,pipe:d=>DateHelper.formatDateTime(d.DateTime)},      
      Config:{title:'檢視',width:60,order:3,pipe:x=>'檢視', click:async x=>{
        var text = (x.Config.Printers as {ReportName:string,PrinterName:string,PaperSize:string}[])
        .map(x=>`${x.ReportName}: ${x.PaperSize}, ${x.PrinterName}`).join('\n');
        await this.confirmService.showAlert('印表機設定',text,{width:800})
      }},
      Identity:{title:'操作',pipe:x=>'套用',width:60,order:4,click:async x=>{
        var ret =await this.confirmService.showConfirm({
          title:'套用設定檔',
          msg:'此操作會覆蓋掉當前主控台的列印設定，是否繼續?'
        });
        if(ret){
          await this.hcrService.setConsoleConfig(x)
        }
      }}
    };
    dialogRef.componentInstance.onClose.subscribe(x => dialogRef.close());

  }
}
